<template>
  <div class="page">
    <!-- 头部 -->
    <YorkbbsHeader :width="'1170px'"></YorkbbsHeader>

    <YorkbbsSkeleton class="kjwt-skeleton row" :count="2" :loading="advLoading">
      <div slot="template" class="kjwt-skeleton__item">
        <el-skeleton-item variant="image"></el-skeleton-item>
      </div>
    </YorkbbsSkeleton>
    <!-- 广告 -->
    <div class="kjwt-row" v-show="!advLoading">
      <YorkbbsAdvItem v-for="i in 20" :key="i" :data="adv[`top_${i}`]"></YorkbbsAdvItem>
    </div>

    <!-- 搜索/导航 -->
    <YorkbbsSearchNav></YorkbbsSearchNav>

    <div class="page-wrapper">
      <!-- 为你优选 -->
      <YorkbbsRecom></YorkbbsRecom>

      <!-- 黄页类别 -->
      <YorkbbsTopics></YorkbbsTopics>

      <!-- 攻略/榜单/专题 -->
      <YorkbbsProject></YorkbbsProject>

      <!-- 发现好店 -->
      <YorkbbsShop></YorkbbsShop>

      <!-- 公共电话 -->
      <YorkbbsPublicPhone></YorkbbsPublicPhone>
    </div>

    <!-- 返回顶部 -->
    <YorkbbsBackup
      :publishVisible="true"
      :publishTitle="'免费发布'"
      :publishURL="'/publish'"
      :merchantVisible="true"
      :opinionVisible="true"
    ></YorkbbsBackup>

    <!-- 底部 -->
    <YorkbbsFooter></YorkbbsFooter>
  </div>
</template>
<script>
import { bannerAdvConvert } from '@/utils/utils';
import YorkbbsHeader from '@/common/header/header.vue';
import YorkbbsSearchNav from '../components/search-nav.vue';
import YorkbbsRecom from './recom.vue';
import YorkbbsTopics from './topics.vue';
import YorkbbsProject from './project.vue';
import YorkbbsShop from './shop.vue';
import YorkbbsPublicPhone from './public-phone.vue';
import YorkbbsFooter from '@/common/footer/footer.vue';
import YorkbbsBackup from '@/common/tools-backup.vue';
import YorkbbsAdvItem from '@/common/item-adv.vue';
import YorkbbsSkeleton from '@/common/skeleton.vue';
export default {
  name: 'Home',
  components: {
    YorkbbsHeader,
    YorkbbsSearchNav,
    YorkbbsRecom,
    YorkbbsTopics,
    YorkbbsProject,
    YorkbbsShop,
    YorkbbsPublicPhone,
    YorkbbsFooter,
    YorkbbsBackup,
    YorkbbsAdvItem,
    YorkbbsSkeleton,
  },
  data() {
    return {
      advLoading: false,
      // 广告
      adv: {},
    };
  },
  created() {
    this.getAdvList();
  },
  methods: {
    /**
     * 获取广告
     */
    async getAdvList() {
      const zoomId = 992809550;

      this.advLoading = true;
      const { data } = await this.$axios.post('/crm/section/v1/get/list/open', { id: zoomId }).finally(() => {
        this.advLoading = false;
      });

      this.adv = bannerAdvConvert(data, 'info', zoomId);
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  width: 1170px;
  margin: auto;
}

::v-deep {
  .kjwt-column {
    .kjwt-item {
      margin-bottom: 10px;
    }
  }

  .kjwt-row {
    width: 1170px;
    display: flex;
    margin: 0 auto;
    .kjwt-item {
      margin: 10px 0;
    }

    .kjwt-item + .kjwt-item {
      margin-left: 10px;
    }
  }
}

.kjwt-skeleton {
  &.row {
    width: 1170px;
    margin: 10px auto;
    ::v-deep {
      .el-skeleton {
        display: flex;
        justify-content: space-between;
      }
      .kjwt-skeleton__item {
        width: 49%;
        height: 90px;
      }
      .el-skeleton__image {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
